import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { FeatureConfigService } from '../services/feature-config.service';
import { FeatureTypes } from '../interfaces/feature-config.interface';
import { of, switchMap } from 'rxjs';

export const CanAccessWorkspace: CanActivateFn = (route, state) => {
  const featureConfigService = inject(FeatureConfigService);
  const router = inject(Router);
  const authService = inject(AuthService);
  const authUser = authService.getAuthUser();
  const isAgencyUser = authUser.userPermissionType === 'AGENCY';

  if (isAgencyUser) {
    router.navigate(['/workspaces/projects']);
    return false;
  }

  return featureConfigService.getTypedFeatureConfig(FeatureTypes.FEA_WORKSPACE_MAIN).pipe(
    switchMap((response) => {
      if (response?.active) {
        return of(true);
      } else {
        router.navigate(['/workspaces/projects']);
        return of(false);
      }
    })
  );
};
